module.exports = __webpack_public_path__ + "static/media/22.afcd6750.gif";